<template>
  <el-dialog
    title="商家信誉图片"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-carousel height="350px">
      <el-carousel-item
        v-for="item in images"
        :key="item">
        <el-image
          style="width: 100%; height: 100%"
          :src="item"
          fit="contain"></el-image>
      </el-carousel-item>
    </el-carousel>
    <span slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ImageModal',
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      visible: false,
      images: []
    }
  },
  methods: {
    handleClosed() {
      this.images = []
    },
    edit(options = []) {
      this.images = options
      this.visible = true
    }
  }
}
</script>
